import { render, staticRenderFns } from "./building-usage.vue?vue&type=template&id=49188302&scoped=true&lang=html&"
import script from "./building-usage.vue?vue&type=script&lang=js&"
export * from "./building-usage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49188302",
  null
  
)

export default component.exports